// @flow

import { pubsub, dom } from "@utils/";

type PropsType = {
    $element: HTMLElement,
};

class SidebarPanel {
    props: PropsType;
    $element: HTMLElement;

    constructor(props: PropsType) {
        // elements
        this.$element = props.$element;
        this.$inner = document.getElementsByClassName("sidebar__inner")[0];
        this.$close = document.getElementsByClassName("js-sidebar__close")[0];
        this.$clsActive = "is-active";
        this.$clsAnimating = "is-animating";
        this.$clsModalOpen = "is-modal-open";

        // kick off
        this.attachHandlers();

        this.init();
    }

    // showHandler(evt) {
    //     let currentTarget = $(evt.currentTarget);
    //     let $target = currentTarget.attr("data-sidebar");
    //     let $sidebarItem = this.$element.find(".sidebar__content");

    //     if ($sidebarItem.hasClass(this.clsActive)) {
    //         $sidebarItem.removeClass(this.clsActive);
    //     }

    //     if ($target) {
    //         // Prevent scroll page
    //         document.body.style.top =
    //             0 - parseInt(window.pageYOffset, 10) + "px";
    //         document.body.classList.add(this.clsModalOpen);

    //         // Attributes accessibility
    //         this.$element.get(0).setAttribute("tabindex", "0");
    //         this.$element.get(0).setAttribute("aria-hidden", "false");
    //         this.$element.get(0).focus();

    //         this.$element.addClass(this.clsActive);
    //         this.$element.addClass(this.clsAnimating);
    //         this.$element.find(".js-sidebar-" + $target).addClass(this.clsActive);

    //         this.activeSidebar = this.$element.find(".js-sidebar-" + $target);
    //         pubsub.publish("onSidebarShow", currentTarget);
    //     }
    // }

    closeHandler() {
        this.$element.classList.remove(this.$clsActive);
        this.$element.classList.add(this.$clsAnimating);
        const that = this;
        setTimeout(function() {
            that.removeAnimation();
        }, 750);
    }

    removeAnimation() {
        this.$element.classList.remove(this.$clsAnimating);
    }

    restoreScroll() {
        // Restore scroll page
        document.body.classList.remove(this.clsModalOpen);
        const scrollTop = parseInt(
            document.body.style.top.replace(/[^\d]+/g, ""),
            10
        );
        window.scrollTo(0, scrollTop);
    }

    attachHandlers() {
        // Close clicking out of it
        this.$element.addEventListener("click", event => {
            event.preventDefault();
            this.closeHandler();
        });

        // Close by button X
        this.$close.addEventListener("click", event => {
            event.preventDefault();
            this.closeHandler();
        });

        // Close by pressing ESC
        // $(document).keyup(e => {
        //     if (e.key === "Escape") {
        //         this.closeHandler();
        //     }
        // });

        // Stop props on children
        this.$inner.addEventListener("click", event => {
            event.stopPropagation();
        });

        // On Animation finish, remove the "is-animating" class.
        // This close moves the animation in frame for entire duration
        dom.onTransitionEndAlways(this.$element, () => {
            this.$element.classList.remove(this.clsAnimating);
        });

        // Close Listener
        pubsub.subscribe("closeSidebar", () => {
            this.closeHandler();
        });

        // SPVPP-176
        // This "fix" stopped our scroll carousel from working properyly. It has been removed
        // It meant that when your cursor was over the carousel, the page would no longer scroll
        // --------------------------------------------------------------------------------------
        // Force scrolling >> blocked due to Dragdrop
        // $(".js-scrollfix").on("mousewheel ", function(e) {
        // 	e = e.originalEvent;
        // 	let delta = e.wheelDelta > 0 || e.detail < 0 ? 1 : -1;
        // 	this.scrollTop -= delta * 30;
        // 	e.preventDefault();
        // });
    }

    init() {
        if (this.$element.length) {
            new SidebarPanel(this.$element);
        }
    }
}

export default SidebarPanel;
